// Helper to normalize backend error responses across the app
export const getApiErrorInfo = (error) => {
  const response = error?.response;
  const data = response?.data || {};
  const nestedError = data.error || {};

  const statusCode = data.statusCode || response?.status || null;
  const code = data.errorCode || data.code || nestedError.code || null;
  const message =
    nestedError.message ||
    data.message ||
    data.error ||
    error?.message ||
    null;

  return { statusCode, code, message, raw: data };
};

